import commonConstant from '../../common/_commonConstant';
import { checkTimeToRefreshToken, getCookieToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetMembershipPackage = buildingID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/building-membership-packages?buildingID=${buildingID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_MEMBERSHIP_PACKAGE_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_MEMBERSHIP_PACKAGE_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_MEMBERSHIP_PACKAGE_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchCreateMembership = (formCreateMembership) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/tenant-members/tenant-member-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'POST',
        'body': JSON.stringify(formCreateMembership),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_MEMBERSHIP_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorCreateMembership) {
        return dispatch({
          'type': commonConstant.CREATE_MEMBERSHIP_FAILURE,
          'data': null,
          'status': res.status ? res.status : res,
          'dateTime': new Date(),
          'errorMessage': data.detail ? data.detail : null,
        });
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_MEMBERSHIP_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_MEMBERSHIP_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchGetMembershipDetail = tenantMemberID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/tenant-members/${tenantMemberID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_MEMBERSHIP_DETAIL_PACKAGE_SUCCESS,
          'data': data.data ? {
            ...data.data,
            'customer': {
              ...data.data.customer,
              'customerInfo': JSON.parse(data.data.customer.customerInfo),
            },
            'tenantMember': {
              ...data.data.tenantMember,
              'tenantMemberInfo': JSON.parse(data.data.tenantMember.tenantMemberInfo),
            },
          } : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_MEMBERSHIP_DETAIL_PACKAGE_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_MEMBERSHIP_DETAIL_PACKAGE_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchUpdateMembership = (tenantMemberID, formUpdateMembership) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/tenant-members/${tenantMemberID}/tenant-member-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PUT',
        'body': JSON.stringify(formUpdateMembership),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_MEMBERSHIP_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorUpdateMembership) {
        return dispatch({
          'type': commonConstant.UPDATE_MEMBERSHIP_FAILURE,
          'data': null,
          'status': res.status ? res.status : res,
          'dateTime': new Date(),
          'errorMessage': data.detail ? data.detail : null,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_MEMBERSHIP_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_MEMBERSHIP_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchGetTenant = buildingID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/tenants?buildingID=${buildingID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_TENANT_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_TENANT_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_TENANT_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchCreateTenant = (formCreateTenant) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/tenants/tenant-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'POST',
        'body': JSON.stringify(formCreateTenant),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_TENANT_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorCreateMembership) {
        return dispatch({
          'type': commonConstant.CREATE_TENANT_FAILURE,
          'data': null,
          'status': res.status ? res.status : res,
          'dateTime': new Date(),
          'errorMessage': data.detail ? data.detail : null,
        });
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_TENANT_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_TENANT_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchUpdateTenant = (formUpdateTenant) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/tenants/tenant-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PUT',
        'body': JSON.stringify(formUpdateTenant),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_TENANT_SUCCESS,
          'data': data.data ? data.data : null,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 400 && data.detail === commonConstant.trowErrorCreateMembership) {
        return dispatch({
          'type': commonConstant.UPDATE_TENANT_FAILURE,
          'data': null,
          'status': res.status ? res.status : res,
          'dateTime': new Date(),
          'errorMessage': data.detail ? data.detail : null,
        });
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_TENANT_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_TENANT_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);
